import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from './RotationKpiMeter';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';

import * as kpiConstants from '../../../constants/kpiConstants';
import * as dataHelper from '../../../helpers/dataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class KpiSelfRatingItem extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            kpi: this.props.kpi,
            activeKpi: this.props.activeKpi,
            locale: appHelper.getLocalData(this.props.kpi),

        };
        this.setActiveClass = this.setActiveClass.bind(this);
        this.onClickFunc = this.onClickFunc.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.activeKpi !== nextProps.activeKpi){
            this.setState({activeKpi: Object.assign(nextProps.activeKpi)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.kpi)
            });
        }
    }
    setActiveClass(){
        //console.log(`${this.state.kpi.value} === ${this.state.activeKpi.value}`);
        return this.state.kpi.value === this.state.activeKpi.value ? "active" : "";
    }

    onClickFunc(event){
        event.stopPropagation();
        this.props.onClickFunc(this.state.kpi);
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.stopPropagation();
            event.preventDefault();
            this.onClickFunc();
        }
    }

    render() {
        return (
            <div className={`${this.props.kpi.class} ${this.setActiveClass()}`} onClick={this.onClickFunc} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={0}/>
        );
    }
}

KpiSelfRatingItem.propTypes = {
    kpi: PropTypes.object.isRequired,
    activeKpi: PropTypes.object.isRequired,
    onClickFunc: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

KpiSelfRatingItem.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiSelfRatingItem);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiSelfRatingItem.js
 **/